import type { LandingPageTestimonial } from '@/app/components/LandingPage/LandingPageTestimonials/types';

export const activityAndMovementTestimonialsDataOR4: LandingPageTestimonial[] =
  [
    {
      id: 'charlie-r',
      image: {
        alt: 'man_cross_fit_alt',
        src: 'activity/cross-fit',
      },
      name: 'Charlie R.',
      quote: 'activity_and_movement_testimonial_charlie_r',
      tag: 'activity_testimonial_tag',
    },
    {
      id: 'rhonda-c',
      image: {
        alt: 'activity_testimonials_two_alt',
        src: 'blue-sky/activity-and-movement/rhonda-c',
      },
      name: 'Rhonda C.',
      quote: 'activity_rhonda_quote',
      tag: 'activity_recovery_tag',
    },
    {
      id: 'marcus-b',
      image: {
        alt: 'activity_testimonials_three_alt',
        src: 'blue-sky/activity-and-movement/marcus-b',
      },
      name: 'Marcus B.',
      quote: 'activity_marcus_quote',
      tag: 'activity_sleep_tag',
    },
  ];
